// extracted by mini-css-extract-plugin
module.exports = {"dosage":"Dosage_dosage__VyXbm","thc":"Dosage_thc__sIWmd","cbd":"Dosage_cbd__8e_oX"};